import React, { ReactNode } from 'react'

import * as MdIcons from 'react-icons/md'
import { useTheme } from 'styled-components'

import { ButtonContainer, ItemsContainer, Spinner, Title } from './styles'

interface IProps {
  onPress: () => void
  children: ReactNode
  isDisabled?: boolean
  isLoading?: boolean
  icon?: string
  secondary?: boolean
}

export const CustomButton = ({
  onPress,
  children,
  isDisabled = false,
  isLoading = false,
  secondary = false,
  icon,
}: IProps) => {
  const theme = useTheme()

  const isNotDisabledAndIsNotLoading = !isDisabled && !isLoading

  const IconComponent = icon
    ? (MdIcons as Record<string, React.ComponentType<{ size: number; color: string }>>)[
        `Md${icon.charAt(0).toUpperCase() + icon.slice(1).replace(/-([a-z])/g, (_, c) => c.toUpperCase())}`
      ]
    : null

  return (
    <ButtonContainer
      type="button"
      $isLoading={isLoading}
      $isDisabled={isDisabled}
      $secondary={secondary}
      onClick={() => isNotDisabledAndIsNotLoading && onPress()}
    >
      {isLoading ? (
        <Spinner $secondary={secondary} />
      ) : (
        <ItemsContainer>
          {IconComponent && (
            <IconComponent
              size={20}
              color={
                secondary
                  ? theme.colors.buttonSecondaryText
                  : theme.colors.buttonPrimaryText
              }
            />
          )}
          <Title $secondary={secondary}>{children}</Title>
        </ItemsContainer>
      )}
    </ButtonContainer>
  )
}
